import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../utils/';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { eapiClient, aemHostClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../layouts/actions/actionCreator';
import { updateCase } from '../actions/actionCreator';

const CreateNewAccount = (props) => {
  const [formJson, setFormJson] = useState();
  const [formData, setFormData] = useState();

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    let apiURL = "/aemData/formData/json_add-account";
    if (props.mode === "edit") {
      apiURL = apiURL.replace("add-", "edit-");
    }
    (async () => {
      const { data } = await aemHostClient(apiURL);
      setFormJson(data);
    })();
    return () => {
      // Anything in here is fired on component unmount.
    }
  }, [])

  useEffect(() => {
    if (props.history.location.pathname.includes("/create-a-case/")) {
      props.hideCrumbs();
    }
    props.hideActionButton();
  }, [])

  const getFormData = (formData) => {
    setFormData(formData)
    // this.setState({ formData });
  }

  const onFormSubmit = (event, apiURL) => {
    const caseId = formData.accountHolder ? (formData.accountHolder.value) : undefined;
    let requestData = { ...formData };
    requestData.caseId = caseId;
    if (props.mode === 'edit') {
      apiURL = apiURL + "/" + formData.id;
    }

    let METHOD = props.mode === 'edit' ? 'PUT' : 'POST';
    (async () => {
      const { data } = await eapiClient(apiURL, {
        method: METHOD,
        data: JSON.stringify(requestData)
      });
      let { caseId } = data.responseData;
      props.updateCase(caseId, 'accounts', Object.assign({}, formData, { id: data.responseData.id }));
      props.history.goBack();
    })();
  }

  const onFormCancel = () => {
    props.history.goBack();
  }

  const renderFormGroups = () => {
    let formData;
    if (props.currentAccount !== undefined) {
      formData = { ...props.currentAccount };
    } else {
      formData = {};
    }
    const properties = {
      accountId: props.match.params.accountId,
      caseId: props.match.params.caseId,
      formData,
      editType: 'add-account-to-case',
      pathname: props.history.location.pathname
    };
    if (formJson !== undefined && formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={props.mode}
          properties={properties}
          url={FORM_REFS[formJson.par.aemform_.formRef]}
          getFormData={getFormData}
          onFormSubmit={onFormSubmit}
          pageJson={formJson}
          onFormCancel={onFormCancel}
          lang={props.lang.currentLang.lang}
          translatedData={props.lang.translatedData}
          flag={props.lang.currentLangFlag.flag} />
      );
    }
  }


  const pageTitle = formJson ? formJson.par.page_title_mainTitle : '';
  return (
    <div>
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">{translations(pageTitle.pageHeading)}</h2>
          <p className="form-required-desc">{translations(pageTitle.descriptionText)}</p>
        </div>
        {renderFormGroups()}
      </div>
    </div>
  );

}


const mapStateToProps = (state, props) => {
  let currentAccount = undefined
  if (props.match.params) {
    var { caseId, accountId } = props.match.params;
    if (caseId && accountId && state.cases[caseId] && state.cases[caseId]['accounts'][accountId]) {
      currentAccount = state.cases[caseId]['accounts'][accountId]
    }
  }
  return {
    currentAccount,
    lang: state.lang,
    mode: currentAccount !== undefined ? 'edit' : ''
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewAccount);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddAccount/CreateNewAccount.js